module.exports = __webpack_public_path__ + "img/quote-icon.3adcaf32.svg";